import "./ActivityConfirmPlanni.scss";
import { useNavigate } from "react-router-dom";
import PrivatePagesWrapper from "components/PrivatePagesWrapper/PrivatePagesWrapper";
import { SuccessActivityConfirmation } from "../../../libs/raas-ui-react-components/src/components";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getDataTmbActivities } from "pages/public/Planner/PlannerFlow.service";
import useSession from "hooks/useSession";
import { ICardTmbActivities } from "pages/public/Planner/PlannerFlow.model";
import { getLanguageTMB } from "pages/public/TmbDetailActivity/TmbDetailActivity.service";
import { getReturnPointSixt, setIdTmbSelect } from "services/user/user.session.service";
import { TmbConfirmPlanniLiterals } from "../TmbConfirmPlanni/TmbConfirmPlanni.utils";
import { getAddressFromCoordinates } from "services/util/globick-service";

declare const window: any;

export default function ActivityConfirmPlanni() {
	const [t, i18n] = useTranslation("tmbConfirmPlanni");
	const [tTmb] = useTranslation("tmbPages");
	const navigate = useNavigate();
	const { logged } = useSession();

	const literalsTmb = {
		titleBanner: tTmb("tmbPlanner.titleBanner"),
		tripDescription: tTmb("tmbPlanner.tripDescription"),
		seeMore: tTmb("tmbPlanner.seeMore"),
	};

	const [activitiesList, setActivitiesList] = useState<ICardTmbActivities>();
	let lenguage = "";

	useEffect(() => {
		if (sessionStorage.getItem("raas-language") != lenguage) {
			lenguage = sessionStorage.getItem("raas-language") as any;	
		}
	}, [t]);

	useEffect(() => {		

        const returnPoint = getReturnPointSixt();
		getAddressFromCoordinates(
			returnPoint.lat,
			returnPoint.lon,
			(response: any) => {
				// setLocation(response);
				if (response === "Barcelona") {
					getTmbActivities(getLanguageTMB(i18n.language));
					window.dataLayer?.push({
						event: "page_view",
						screen_name: "purchase_confirm",
						screen_class: "trip_confirm",
						content_name: "social_login",
						option_selected: "bnc_globick",
					});
				}
			},
			(e: any) => console.log("error", e),
		);
	}, []);

	const getTmbActivities = (lenguage: any) => {
		getDataTmbActivities(
			logged,
			(response: any) => {
				setActivitiesList(response);
			},
			(err: any) => {},
			lenguage,
			window.sessionStorage["raas-trip-mock"],
		);
	};

	//Funcion que recoge la activida seleccionada
	const goSeeMoreTmb = (e: any) => {
		if (e.detail) {
			//Variable de session para saber que imagen hay que cargar en el detalle
			window.sessionStorage.setItem(
				"raas-id-tmb-image-select",
				e.detail.image,
			);
			setIdTmbSelect(e.detail.id);
			navigate("/detail-activy");
		}
	};
	return (
		<>
			<div className="confirm-container">
				<SuccessActivityConfirmation
					literalsTmb={literalsTmb}
					activitiesList={activitiesList}
					onButtonEventClick={(ev: CustomEvent) =>
						navigate(ev?.detail)
					}
					literals={TmbConfirmPlanniLiterals(t)}
					onNavigateSeeMore={goSeeMoreTmb}
				></SuccessActivityConfirmation>
			</div>
			<PrivatePagesWrapper></PrivatePagesWrapper>
		</>
	);
}
